import { BaseContent, ModalBox, useModalContext } from '@fourthwall/components';
import React from 'react';
export const VideoModal = ({ title, description, video }) => {
    const { close } = useModalContext();
    return (React.createElement(ModalBox, { title: title, size: "large", onClose: close },
        React.createElement(BaseContent, null, description),
        React.createElement("div", { style: { marginTop: 24 } }, video)));
};
